var FormValidator = require('../../modules/FormValidator');

var BookingCreateValidator = function (form, onSuccess, onError) {
    var rules = {
        first_name: {
            validators: {
                notEmpty: {
                    message: 'The first name is required',
                },
            },
        },
        last_name: {
            validators: {
                notEmpty: {
                    message: 'The surname is required',
                },
            },
        },
        email: {
            validators: {
                notEmpty: {
                    message: 'The email address is required',
                    emailAddress: 'The email address is not valid',
                },
            },
        },
        phone: {
            validators: {
                notEmpty: {
                    message: 'The contact number is required',
                },
            },
        },
        address1: {
            validators: {
                notEmpty: {
                    message: 'The billing address is required',
                },
            },
        },
        city: {
            validators: {
                notEmpty: {
                    message: 'The city is required',
                },
            },
        },
        postcode: {
            validators: {
                notEmpty: {
                    message: 'The postcode is required',
                },
            },
        },
        country: {
            validators: {
                notEmpty: {
                    message: 'The country is required',
                },
            },
        },
        payment_reference: {
            validators: {
                notEmpty: {
                    message: 'The payment reference is required',
                },
            },
        },
    };

    FormValidator(form, rules, onSuccess, onError);
};

module.exports = BookingCreateValidator;



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/validation/BookingCreate.js